import { useCallback, useState } from 'react'
import TagManager from "react-gtm-module"
import { isEmpty } from '../../../../utils/stringUtils'
import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { useStep6Props, Step6Props } from '../types'
import useStep6Data from './useStep6.data'

const useStep6 = (props: useStep6Props): Step6Props => {
    const { data: activationObject, update, isUpdating } = useActivationObject()
    const formProps = useStep6Data(activationObject)
    const [note, setNote] = useState<string>(activationObject?.note || '')
    const handleSetNote = useCallback((val: string) => setNote(val), [])

    const onSubmit = useCallback(() => {
        if (activationObject) {
            TagManager.dataLayer({
                dataLayer: {
                    'event': 'clickFinish',
                }
            });

            const newObject: ActivationObject = {
                ...activationObject,
                note: !isEmpty(note) ? note : null,
                wizardStep: 'Finish',
            }

            update(newObject)
        }
    }, [activationObject, note, update])

    return {
        ...props,
        dataProps: formProps,
        onSubmit,
        isUpdating,
        note,
        handleSetNote,
    }
}

export default useStep6
